import { Book } from 'lucide-react';

import { Datatable } from '@@/datatables';
import { useTableStateWithStorage } from '@@/datatables/useTableState';

import { Repository } from './types';
import { columns } from './columns';

export function RepositoriesDatatable({
  dataset,
  isLoading,
}: {
  dataset?: Repository[];
  isLoading: boolean;
}) {
  const tableState = useTableStateWithStorage('registryRepositories');
  return (
    <Datatable
      title="Repositories"
      titleIcon={Book}
      columns={columns}
      dataset={dataset || []}
      isLoading={isLoading}
      settingsManager={tableState}
      disableSelect
      data-cy="registry-repositories-datatable"
    />
  );
}
